import React from 'react'
import styled from 'styled-components';
import {Check} from 'react-feather';


const Success = ({message, padding, margin}) => {
  return (
    <>
    {message &&
        <Card padding={padding} margin={margin}>
            <Icon><Check/></Icon>
            <Message><span>{message}</span></Message>
        </Card>
    }
    </>
  )
}

export default Success

const Card = styled.div`
    background-color: var(--color-exito-claro);
    border: 1px solid var(--color-exito);
    border-radius: 5px;
    display: flex;
    padding: ${props=> props.padding? props.padding : '16px'};
    width:70%;
    align-items:center;
    margin: ${props=> props.margin? props. margin : '16px'};
`;

const Icon = styled.div`
    margin-right:16px;
    color: var(--color-exito)
`;


const Message = styled.div`
`;



